import { hasRole } from "@data/utility/ability"
import { useMemo } from "react"
import { useSelector } from "react-redux"
import { createTelemetry } from "../../../engine/shared/telemetry"

// The old live's buttons report a camera or a microphone the device cannot open
// the way the engine's live does, under the same machine and steps, so one
// failure lands in one Bugsnag group whichever live the person is in.
export function useLiveDeviceTelemetry() {
    const role = useSelector((state) =>
        hasRole(state.data.currentUser?.object, "tutor") ? "tutor" : "student"
    )
    return useMemo(() => createTelemetry(`live-${role}`, { role }), [role])
}
